import { ChangeDetectionStrategy, Component, OnInit, inject, input } from '@angular/core';
import { BehaviorSubject, combineLatest, distinctUntilChanged, map } from 'rxjs';
import { AusResult, AusResultStatusIcon, LpaResult, LpaResultStatusIcon } from '../../../aus/models';
import { Cmg1003Model } from '../../../cmg-1003/models';
import { getDuLpaResult } from '../../../loan-banner/models/aus-status.models';
import { AusQuery, Cmg1003LoanQuery, Cmg1003StoreQueryService } from '../../../loan-state';
import { SecurityProfileModel, SecurityProfileStore } from '../../../loan-state/security-profile';
import { BusinessChannel } from '../../../models';
import { AppSettingsService } from '../../services';
import { FeatureFlagRepository, FeatureName } from '../../../core/state';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'cmg-clear2-ui-aus-status-chip',
  templateUrl: './aus-status-chip.component.html',
  styleUrls: ['./aus-status-chip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe],
})
export class AusStatusChipComponent implements OnInit {
  private readonly _ausQuery = inject(AusQuery);
  private readonly _loanQuery = inject(Cmg1003LoanQuery);
  private readonly _cmgStoreQuery = inject(Cmg1003StoreQueryService);
  private readonly _securityProfileStore = inject(SecurityProfileStore);
  private readonly _appSettingsService = inject(AppSettingsService);
  private readonly _featureFlagsRepository = inject(FeatureFlagRepository);

  readonly separator = input(false);

  readonly all1003 = input<Cmg1003Model>(undefined);

  AusResult = AusResult;
  LpaResult = LpaResult;
  ausResult$ = null;
  isSandboxLoan$ = this._cmgStoreQuery.isSandboxLoan$;
  isShowSandboxLoanLpa$ = this._appSettingsService.isShowSandboxLoanLpa$;

  LpaResultStatusIcon = LpaResultStatusIcon;
  AusResultStatusIcon = AusResultStatusIcon;

  activeProfile: SecurityProfileModel;
  BusinessChannel = BusinessChannel;

  private _isShowLpa$ = new BehaviorSubject(true);
  isShowLpa$ = this._isShowLpa$.asObservable();
  private _isSandboxLoanMVP2Enabled$ = this._featureFlagsRepository.isFeatureEnabled$(FeatureName.SandboxLoanMVP2);

  ngOnInit(): void {
    const securityProfileStoreValue: any = this._securityProfileStore.getValue();
    this.activeProfile = securityProfileStoreValue?.entities[securityProfileStoreValue.active];

    combineLatest([this.isSandboxLoan$, this.isShowSandboxLoanLpa$, this._isSandboxLoanMVP2Enabled$])
      .pipe(distinctUntilChanged())
      .subscribe(([isSandboxLoan, isShowSandboxLoanLpa, isSandboxLoanMVP2Enabled]) => {
        if (isSandboxLoan && !isShowSandboxLoanLpa && !isSandboxLoanMVP2Enabled) {
          this._isShowLpa$.next(false);
        }
      });

    this.ausResult$ = combineLatest([this._ausQuery.select((t) => t.orderLogs), this._loanQuery.select((t) => t.mortgageAppliedFor)]).pipe(
      distinctUntilChanged(),
      map(([orderLogs, mortgageAppliedFor]) => getDuLpaResult(mortgageAppliedFor, orderLogs)),
    );
  }
}
